import { Navigate } from "react-router-dom";
import { authAtom } from "./recoil/atoms";
import { useRecoilValue } from "recoil";

const ProtectedRoute = ({ children }) => {
  const user = useRecoilValue(authAtom);
  const isLoggedIn = user.isLoggedIn;

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
